import {
    DELETE_KYCCONFIGURATIONRECORD_SUCCESS,
    DELETE_KYCCONFIGURATIONRECORD_FAILED,
    RESET_DELETE_KYCCONFIGURATIONRECORD,
    LOADING_DELETE_KYCCONFIGURATIONRECORD,
    NETWORK_ERROR_DELETE_KYCCONFIGURATIONRECORD,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DELETE_KYCCONFIGURATIONRECORD:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case DELETE_KYCCONFIGURATIONRECORD_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case DELETE_KYCCONFIGURATIONRECORD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_DELETE_KYCCONFIGURATIONRECORD:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_DELETE_KYCCONFIGURATIONRECORD:
            return (state = initialState);
        default:
            return state;
    }
};
